import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { setFormFieldValue, validateFormField } from '../../../reducers/formReducer'

export class GenderField extends Component {
  constructor(props) {
    super(props)
    this.valueChange = this.valueChange.bind(this)
  }

  componentDidMount() {
    const { formType, fieldName, defaultValue } = this.props
    const initialValue = defaultValue || ''
    this.props.setFormFieldValue(formType, fieldName, initialValue)
    this.props.validateFormField(formType, fieldName, this.isValid(initialValue))
  }

  componentWillReceiveProps(nextProps) {
    const { formType, fieldName, defaultValue } = this.props
    if (defaultValue !== nextProps.defaultValue) {
      this.props.setFormFieldValue(formType, fieldName, nextProps.defaultValue)
      this.props.validateFormField(formType, fieldName, this.isValid(nextProps.defaultValue))
    }
  }

  valueChange(e) {
    const { formType, fieldName, isDisabled } = this.props
    if (isDisabled) {
      e.preventDefault()
      return false
    }
    this.props.setFormFieldValue(formType, fieldName, e.target.value)
    this.props.validateFormField(formType, fieldName, this.isValid(e.target.value))
  }

  isValid(val) {
    return val !== '' && (val === 'Male' || val === 'Female')
  }

  render() {
    const { form, formType, fieldName, label, additionalClass, isDisabled } = this.props
    return (
      <div
        className={`field field-gender ${additionalClass || ''} ${
          isDisabled ? 'field--disabled' : ''
        }`}
      >
        <label htmlFor={fieldName} className="label">
          {label}
        </label>
        <div>
          <input
            type="radio"
            name={fieldName}
            id="male"
            value="Male"
            onChange={this.valueChange}
            checked={form[formType][fieldName].value === 'Male'}
          />
          <label htmlFor="male">Male</label>
        </div>
        <div>
          <input
            type="radio"
            name={fieldName}
            id="female"
            value="Female"
            onChange={this.valueChange}
            checked={form[formType][fieldName].value === 'Female'}
          />
          <label htmlFor="female">Female</label>
        </div>
      </div>
    )
  }
}

GenderField.propTypes = {
  form: PropTypes.object,
  formType: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  additionalClass: PropTypes.string,
  setFormFieldValue: PropTypes.func,
  validateFormField: PropTypes.func,
  isDisabled: PropTypes.bool,
}

export default connect(
  (state) => {
    return {
      form: state.form,
    }
  },
  { setFormFieldValue, validateFormField },
)(GenderField)
